import Duck from 'extensible-duck';

export default new Duck({
  namespace: 'GEWEB',
  store: 'COMMON',
  initialState: {
    globalLoading: false,
  },
  types: [
    'FETCH_CONFIGURATION',
    'START_GLOBAL_LOADING',
    'STOP_GLOBAL_LOADING',
    'FETCH_BOOKING_CONFIGURATION',
  ],
  creators: duck => ({
    fetchConfiguration: (countryCode, cityCode, cityID) => ({
      type: duck.types.FETCH_CONFIGURATION,
      countryCode,
      cityCode,
      cityID,
    }),
    startGlobalLoading: () => ({ type: duck.types.START_GLOBAL_LOADING }),
    stopGlobalLoading: () => ({ type: duck.types.STOP_GLOBAL_LOADING }),
  }),
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.START_GLOBAL_LOADING: {
        return {
          ...state,
          globalLoading: true,
        };
      }
      case duck.types.STOP_GLOBAL_LOADING: {
        return {
          ...state,
          globalLoading: false,
        };
      }
    }
    return state;
  },
});
